import { Dropdown, FC} from 'external/react'
import Icon from 'external/fortawesome'

type PaymentItemOptionsProps = {
    index: number,
    payment: any,
    handleOpenDetail: (index: number) => void
		handleChangePaymentMethod: (index: number) => void
}

export const PaymentItemOptions:FC<PaymentItemOptionsProps> = props => {
  const {index, payment, handleOpenDetail, handleChangePaymentMethod} = props
  const {lastInvoiceUrl} = payment

	return (<Dropdown>
    <Dropdown.Toggle variant='link' id='dropdown-basic' className='dropdown-style' style={{ color: '#575151' }}>
        <Icon name='faEllipsisVertical' style={{ fontSize: '25px' }} />
      </Dropdown.Toggle>

      <Dropdown.Menu>
        <Dropdown.Item as='button' onClick={() => handleOpenDetail(index)} >
          <span>Detalle</span>
        </Dropdown.Item>
				{lastInvoiceUrl && (
					<Dropdown.Item href={lastInvoiceUrl} target='_blank' >
						<span>Ver recibo de último pago</span>
					</Dropdown.Item>
				)}
				{payment.paymentMode === 'subscription' && (
					<Dropdown.Item href={`/home/payment/history?subscription=${payment.subscription}`}>
					<span>Historial de pagos</span>
				</Dropdown.Item>
				)}
				{payment.paymentMode === 'subscription' && (
					<Dropdown.Item as='button' onClick={() => handleChangePaymentMethod(index) } >
						<span>Cambiar método de pago</span>
					</Dropdown.Item>
				)}
      </Dropdown.Menu>
    </Dropdown>
  )
}